import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { hideModal } from '../../actions/ModalActions';

const WebsiteOnboardSuccessModal = (props) => {
  const { closeModal } = props;
  return (
    <div className="text-center">
      <div className="modal-header">
        <h1>Great!</h1>
        <h3>Now, let&apos;s setup the pages for your website & app.<br />We&apos;ll start with the homepage.</h3>
      </div>
      <div className="modal-body">
        <Link to="/wedding/manage/website/pages" onClick={closeModal} className="btn btn-primary">
          Next, setup Homepage
        </Link>
      </div>
    </div>
  );
};

WebsiteOnboardSuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapModalDispatchToProps = dispatch => (
  {
    closeModal: () => dispatch(hideModal())
  }
);

// eslint-disable-next-line import/prefer-default-export
export const WebsiteOnboardSuccessModalContainer = connect(null, mapModalDispatchToProps)(WebsiteOnboardSuccessModal);



// WEBPACK FOOTER //
// ./src/components/onboard/WebsiteOnboard.jsx